import { Component } from "@angular/core";
import { BreadcrumbItemComponent } from "@m19-board/shared/breadcrumb-item/breadcrumb-item.component";
import { SbStrategyFormComponent } from "@m19-board/strategies/sb-strategy-form/sb-strategy-form.component";
import { TranslocoDirective } from "@jsverse/transloco";
import { NavBreadcrumbDirective } from "@m19-board/containers/page-layout/nav-breadcrumb.directive";

@Component({
  selector: "sb-strategy-form-page",
  standalone: true,
  imports: [BreadcrumbItemComponent, SbStrategyFormComponent, TranslocoDirective, NavBreadcrumbDirective],
  templateUrl: "./sb-strategy-form-page.component.html",
})
export class SbStrategyFormPageComponent {}
